export function routine(impl) {
    return { _impl: impl };
}
export function asyncRoutine(impl) {
    return { _implAsync: impl };
}
export function routineOf(fn) {
    return {
        _impl: fn,
    };
}
export function asyncRoutineOf(fn) {
    return {
        _implAsync: fn,
    };
}
